import React from "react";
import { Box, Typography , Divider } from "@mui/material";
const ViewAlertDetails = ({ messageDetails }) => {
  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "start",
          width: "100%",
          flexDirection: "column",
          gap: "10px",
        }}
      >
        <Typography
          sx={{
            fontSize: ".875",
            fontWeight: 550,
            color: "#050D2E",
            marginLeft: "10px",
          }}
        >
          Template Name
          <Typography
            sx={{
              fontSize: "14px",
              fontWeight: "normal",
              color: "#050D2E",
              marginLeft: "10px",
            }}
            display="inline"
          >
            {messageDetails.Template}
          </Typography>
        </Typography>
        <Typography
          sx={{
            fontSize: ".875",
            fontWeight: 550,
            color: "#050D2E",
            marginLeft: "10px",
          }}
        >
          Criteria Name
          <Typography
            sx={{
              fontSize: "14px",
              fontWeight: "normal",
              color: "#050D2E",
              marginLeft: "10px",
            }}
            display="inline"
          >
            {messageDetails.criteriaName}
          </Typography>
        </Typography>
        <Typography
          sx={{
            fontSize: ".875",
            fontWeight: 550,
            color: "#050D2E",
            marginLeft: "10px",
          }}
        >
          Generated Date
          <Typography
            sx={{
              fontSize: "14px",
              fontWeight: "normal",
              color: "#050D2E",
              marginLeft: "10px",
            }}
            display="inline"
          >
            {messageDetails.generatedDate}
          </Typography>
        </Typography>
      </Box>
      <Typography
        sx={{
          fontSize: ".875",
          fontWeight: 550,
          color: "#050D2E",
          margin: "20px 0px 5px 10px",
        }}
      >
        {messageDetails.omniType}
      </Typography>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          bgcolor: "#ffffff",
          p: "2px",
          border: "1px solid #D3D8E3",
          borderRadius: "4px",
          margin: "0px 0px 5px 10px",

        }}
      >
        <Typography
         sx={{
            fontSize: "0.875",
            padding: "10px",
          }}
        >
          {messageDetails.omniMessage}
        </Typography>
      </Box>
      <Divider sx={{mt:3}} variant="middle" />

    </>
  );
};

export default ViewAlertDetails;
